exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-bg[data-v-4976df74]{background-color:#f5f5f5}", ""]);

// exports
